/* Gym Nano rack fit checker.
   Lazy: the rack database is only fetched the first time the dialog opens.
   Fit rules confirmed by Speediance 2026-09-14.
   Boot: window.BMRF.open() — the button in snippets/nano-mount-helper.liquid calls it. */
(function () {
  'use strict';
  if (window.BMRF) return;

  var SLIDE = { min: 74, max: 77, hole: 15 };
  var FIXED = { min: 49.5, max: 77, hole: 15, pMin: 49, pMax: 51.5 };

  var RACKS = null, loading = null, dlg = null, brandOpen = false;
  var answers = { u: null, p: null, t: null };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmt(n) { return n == null ? '?' : String(Math.round(n * 10) / 10).replace(/\.0$/, ''); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }

  function judge(r) {
    var u = r.u == null ? null : r.u, d = r.d == null ? null : r.d,
        p = r.p == null ? null : r.p, t = r.t == null ? null : !!r.t;
    var o = { slide: 'no', fixed: 'no', why: [], check: [] };
    if (u == null) { o.slide = o.fixed = 'unknown'; return o; }

    if (u >= SLIDE.min && u <= SLIDE.max) {
      if (d == null) { o.slide = 'yes'; o.check.push('Hole diameter is not published for this rack. It needs to be 15 mm (5/8 in) or larger, which nearly every 75 mm rack is.'); }
      else if (d >= SLIDE.hole) { o.slide = 'yes'; }
      else { o.why.push('Sliding mount: the holes are ' + fmt(d) + ' mm, under the 15 mm minimum.'); }
    } else {
      o.why.push('Sliding mount: needs a 75 x 75 mm upright. Yours is ' + fmt(u) + ' mm.');
    }

    if (u < FIXED.min || u > FIXED.max) {
      o.why.push('Fixed mount: needs 50 to 75 mm. Yours is ' + fmt(u) + ' mm.');
    } else {
      var ho = d == null ? null : d >= FIXED.hole;
      var po = p == null ? null : (p >= FIXED.pMin && p <= FIXED.pMax);
      if (ho === false) { o.why.push('Fixed mount: the holes are ' + fmt(d) + ' mm, under the 15 mm minimum.'); }
      else if (po === false) { o.why.push('Fixed mount: the hole spacing is ' + fmt(p) + ' mm. It has to be 50 mm or 2 inches (50.8 mm).'); }
      else if (t === false) { o.why.push('Fixed mount: the bolts have to pass straight through the upright, and this rack does not have through holes.'); }
      else if (po === null) {
        // Hole spacing is the decisive unknown and varies far too much to assume.
        o.fixed = 'maybe';
        o.why.push('Fixed mount: the hole spacing is not published for this rack. Measure ten gaps and divide by ten to be sure.');
      } else {
        // Spacing and size both check out. Hole diameter and through-holes are almost
        // never published, and nearly every pin-style rack satisfies both, so this is a
        // yes with the checks named rather than a permanent maybe.
        o.fixed = 'yes';
        if (ho === null) o.check.push('Hole diameter is not published. It needs to be 15 mm (5/8 in) or larger, which nearly every rack taking 50 mm or 2 inch spacing is.');
        if (t === null) o.check.push('We could not confirm the holes pass straight through. Shine a torch into one hole and look from the other side.');
      }
    }
    return o;
  }

  function search(q, n) {
    var nq = norm(q);
    if (nq.length < 2) return [];
    var terms = nq.split(' ').filter(Boolean), out = [];
    for (var i = 0; i < RACKS.length; i++) {
      var r = RACKS[i];
      var hay = norm(r.b + ' ' + r.m + ' ' + (r.a || []).join(' '));
      var s = 0, ok = true;
      for (var j = 0; j < terms.length; j++) {
        var at = hay.indexOf(terms[j]);
        if (at === -1) { ok = false; break; }
        s += (at === 0 ? 12 : 6) + Math.max(0, 6 - at / 6);
      }
      if (!ok) continue;
      if (norm(r.b).indexOf(terms[0]) === 0) s += 10;
      if (norm(r.m).indexOf(terms[0]) === 0) s += 8;
      out.push([s - Math.min(6, hay.length / 30), r]);
    }
    out.sort(function (a, b) { return b[0] - a[0]; });
    return out.slice(0, n || 8).map(function (x) { return x[1]; });
  }

  var SEG = { c: 'Commercial and high end', p: 'Premium', h: 'Home gym', b: 'Budget and mass retail' };
  var SEGO = ['c', 'p', 'h', 'b'];

  function tag(state, label) {
    if (state === 'unknown') return '';
    var c = state === 'yes' ? 'y' : state === 'no' ? 'n' : 'q';
    var t = state === 'yes' ? label + ' fits' : state === 'no' ? label + ' no' : label + '?';
    return '<span class="bmrf-t ' + c + '">' + t + '</span>';
  }

  function renderResults(list) {
    var ul = dlg.querySelector('#bmrf-res');
    ul.innerHTML = list.map(function (r) {
      var v = judge(r), i = RACKS.indexOf(r);
      var sub = r.u != null ? fmt(r.u) + ' mm upright' : 'upright not published';
      if (r.p != null) sub += ' · ' + fmt(r.p) + ' mm spacing';
      var tags = v.slide === 'unknown' ? '<span class="bmrf-t">measure needed</span>' : tag(v.slide, 'Slide') + tag(v.fixed, 'Fixed');
      return '<li><button type="button" data-i="' + i + '"><span class="bmrf-rb">' + esc(r.b + ' ' + r.m) +
        '</span><span class="bmrf-rs">' + esc(sub) + '</span><span class="bmrf-tags">' + tags + '</span></button></li>';
    }).join('');
    Array.prototype.forEach.call(ul.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () { verdict(RACKS[+b.dataset.i]); });
    });
  }

  function buildBrands() {
    var by = {};
    RACKS.forEach(function (r) {
      var e = by[r.b] || (by[r.b] = { n: r.b, c: 0, s: {} });
      e.c++; e.s[r.s] = (e.s[r.s] || 0) + 1;
    });
    var groups = {};
    Object.keys(by).forEach(function (k) {
      var e = by[k], top = 'h', best = -1;
      SEGO.forEach(function (g) { if ((e.s[g] || 0) > best) { best = e.s[g] || 0; top = g; } });
      (groups[top] = groups[top] || []).push(e);
    });
    return SEGO.filter(function (g) { return groups[g] && groups[g].length; }).map(function (g) {
      var l = groups[g].sort(function (a, b) { return b.c - a.c || a.n.localeCompare(b.n); });
      return '<div class="bmrf-bg"><h4>' + esc(SEG[g]) + '</h4><div class="bmrf-chips">' +
        l.map(function (e) {
          return '<button type="button" class="bmrf-chip" data-brand="' + esc(e.n) + '" aria-pressed="false">' +
            esc(e.n) + '<span class="c">' + e.c + '</span></button>';
        }).join('') + '</div></div>';
    }).join('');
  }

  function verdict(r) {
    var v = judge(r), cls, label, title, body;
    var both = v.slide === 'yes' && v.fixed === 'yes';
    if (v.slide === 'unknown') {
      cls = 'q'; label = 'Specification not published';
      title = 'We need you to measure this one';
      body = 'This manufacturer does not publish upright dimensions for this rack. We will not guess at a fit on something you are going to hang weight from. Three questions and a tape measure settle it.';
    } else if (both) {
      cls = 'y'; label = 'Both mounts fit'; title = 'Choose the Sliding Rack Mount';
      body = 'Both fit this rack. We recommend the Sliding Rack Mount because it slides to any height on the upright, where the Fixed mount is bolted at one height and has to be unbolted to move.';
    } else if (v.slide === 'yes') {
      cls = 'y'; label = 'Fits'; title = 'Sliding Rack Mount';
      body = 'This rack takes the Sliding Rack Mount. It attaches at 90 degrees to the machine and slides to any height on the upright.';
    } else if (v.fixed === 'yes') {
      cls = 'y'; label = 'Fits'; title = 'Fixed Rack Mount';
      body = 'This rack takes the Fixed Rack Mount. It bolts through the upright at 0 degrees, in line with the machine.';
    } else if (v.fixed === 'maybe') {
      cls = 'q'; label = 'Probably, one thing to check'; title = 'Fixed Rack Mount, likely';
      body = 'This looks like a fit, but a measurement is missing from the published specification. Check it with a tape measure, or send us the model and we will confirm before your order ships.';
    } else {
      cls = 'n'; label = 'No mount fits'; title = 'Neither mount fits this rack';
      body = 'Gym Nano cannot be mounted on this rack with the mounts we sell today. A platform mount that does not need a rack at all is in development. Send us your rack and we will tell you when something fits it.';
    }

    var sp = [
      ['Upright', r.u != null ? fmt(r.u) + ' mm' : 'not published'],
      ['Hole size', r.d != null ? fmt(r.d) + ' mm' : 'not published'],
      ['Hole spacing', r.p != null ? fmt(r.p) + ' mm' : 'not published'],
      ['Through holes', r.t == null ? 'not published' : (r.t ? 'yes' : 'no')]
    ];

    var el = dlg.querySelector('#bmrf-v');
    el.className = 'bmrf-v ' + cls;
    el.innerHTML = '<span class="bmrf-vl">' + esc(label) + '</span><div class="bmrf-vt">' + esc(title) + '</div>' +
      (r.b !== 'Your rack' ? '<p class="bmrf-vb" style="font-weight:600;opacity:1">' + esc(r.b + ' ' + r.m) + '</p>' : '') +
      '<p class="bmrf-vb">' + esc(body) + '</p>' +
      '<dl class="bmrf-sp">' + sp.map(function (s) {
        return '<div><dt>' + esc(s[0]) + '</dt><dd>' + esc(s[1]) + '</dd></div>';
      }).join('') + '</dl>' +
      (v.check.length ? '<p class="bmrf-why"><strong>One thing to check:</strong> ' + v.check.map(esc).join(' ') + '</p>' : '') +
      (v.why.length ? '<p class="bmrf-why"><strong>Why:</strong> ' + v.why.map(esc).join(' ') + '</p>' : '') +
      (v.slide === 'unknown' ? '<div class="bmrf-act"><button type="button" class="bmrf-btn" data-goto="m">Measure this rack now</button></div>' : '');

    Array.prototype.forEach.call(el.querySelectorAll('[data-goto="m"]'), function (b) {
      b.addEventListener('click', function () { dlg.querySelector('.bmrf-tab[data-p="m"]').click(); });
    });
    dlg.querySelector('#bmrf-vw').hidden = false;
    dlg.querySelector('#bmrf-vw').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function maybeJudge() {
    var u = typeof answers.u === 'number' ? answers.u : null;
    var p = typeof answers.p === 'number' ? answers.p : null;
    var t = answers.t === 'yes' ? 1 : answers.t === 'no' ? 0 : null;
    if (u == null) { dlg.querySelector('#bmrf-vw').hidden = true; return; }
    var slideSize = u >= SLIDE.min && u <= SLIDE.max;
    if (!slideSize && (p == null || t == null)) { dlg.querySelector('#bmrf-vw').hidden = true; return; }
    verdict({ b: 'Your rack', m: '', u: u, d: null, p: p, t: t });
  }

  function wire() {
    var q = dlg.querySelector('#bmrf-q'), t;
    q.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        Array.prototype.forEach.call(dlg.querySelectorAll('.bmrf-chip'), function (c) { c.setAttribute('aria-pressed', 'false'); });
        var list = search(q.value, 8);
        renderResults(list);
        dlg.querySelector('#bmrf-none').hidden = !(norm(q.value).length >= 2 && list.length === 0);
      }, 90);
    });

    Array.prototype.forEach.call(dlg.querySelectorAll('.bmrf-tab'), function (tab) {
      tab.addEventListener('click', function () {
        Array.prototype.forEach.call(dlg.querySelectorAll('.bmrf-tab'), function (x) { x.setAttribute('aria-selected', 'false'); });
        tab.setAttribute('aria-selected', 'true');
        dlg.querySelector('#bmrf-ps').hidden = tab.dataset.p !== 's';
        dlg.querySelector('#bmrf-pm').hidden = tab.dataset.p !== 'm';
        dlg.querySelector('#bmrf-pc').hidden = tab.dataset.p !== 'c';
        dlg.querySelector('#bmrf-vw').hidden = true;
      });
    });

    Array.prototype.forEach.call(dlg.querySelectorAll('[data-goto]'), function (el) {
      el.addEventListener('click', function () {
        var t = dlg.querySelector('.bmrf-tab[data-p="' + el.getAttribute('data-goto') + '"]');
        if (t) t.click();
      });
    });

    ['u', 'p', 't'].forEach(function (g) {
      Array.prototype.forEach.call(dlg.querySelectorAll('[data-g="' + g + '"]'), function (btn) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(dlg.querySelectorAll('[data-g="' + g + '"]'), function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          var raw = btn.dataset.v;
          answers[g] = (raw === 'yes' || raw === 'no') ? raw : (raw === 'other' ? 'other' : parseFloat(raw));
          var cu = dlg.querySelector('[data-cu="' + g + '"]');
          if (cu) cu.hidden = raw !== 'other';
          maybeJudge();
        });
      });
      var cu = dlg.querySelector('[data-cu="' + g + '"] input');
      if (cu) cu.addEventListener('input', function () {
        var v = parseFloat(cu.value);
        answers[g] = isFinite(v) && v > 0 ? v : 'other';
        maybeJudge();
      });
    });

    dlg.querySelector('#bmrf-brands').innerHTML = buildBrands();
    Array.prototype.forEach.call(dlg.querySelectorAll('.bmrf-chip'), function (chip) {
      chip.addEventListener('click', function () {
        var on = chip.getAttribute('aria-pressed') === 'true';
        Array.prototype.forEach.call(dlg.querySelectorAll('.bmrf-chip'), function (c) { c.setAttribute('aria-pressed', 'false'); });
        if (on) { dlg.querySelector('#bmrf-res').innerHTML = ''; return; }
        chip.setAttribute('aria-pressed', 'true');
        dlg.querySelector('#bmrf-q').value = '';
        dlg.querySelector('#bmrf-none').hidden = true;
        renderResults(RACKS.filter(function (r) { return r.b === chip.dataset.brand; })
          .sort(function (a, b) { return String(a.m).localeCompare(String(b.m), undefined, { numeric: true }); }).slice(0, 80));
      });
    });

    dlg.querySelector('#bmrf-count').textContent = RACKS.length;
    dlg.querySelector('#bmrf-bcount').textContent = String(Object.keys(RACKS.reduce(function (a, r) { a[r.b] = 1; return a; }, {})).length);
  }

  function shell() {
    return '<div class="bmrf-shell"><div class="bmrf-head"><div>' +
      '<h2>Which mount fits your rack?</h2>' +
      '<p>Gym Nano bolts to a squat rack upright. There are two mounts and they fit different racks.</p>' +
      '</div><button type="button" class="bmrf-x" id="bmrf-x" aria-label="Close">&times;</button></div>' +
      '<div class="bmrf-body" id="bmrf-body"><div class="bmrf-load">Loading rack data…</div></div></div>';
  }

  function panes() {
    return '<div class="bmrf-tabs" role="tablist">' +
      '<button class="bmrf-tab" role="tab" data-p="s" aria-selected="true">Find my rack</button>' +
      '<button class="bmrf-tab" role="tab" data-p="m" aria-selected="false">Measure it</button>' +
      '<button class="bmrf-tab" role="tab" data-p="c" aria-selected="false">Compare mounts</button></div>' +

      '<div class="bmrf-pane" id="bmrf-ps">' +
        '<div><label class="bmrf-lbl" for="bmrf-q">Start typing your rack brand or model</label>' +
        '<input type="text" class="bmrf-in" id="bmrf-q" autocomplete="off" spellcheck="false" placeholder="Mirafit M3, REP PR-4000, Force USA MyRack, ATX PRX-750…">' +
        '<p class="bmrf-hint"><span id="bmrf-count">0</span> racks from <span id="bmrf-bcount">0</span> brands across the UK, Europe, Australia and New Zealand.</p>' +
        '<ul class="bmrf-res" id="bmrf-res"></ul>' +
        '<div class="bmrf-empty" id="bmrf-none" hidden><strong>Not on the list.</strong> There are thousands of racks and no manufacturer publishes a central database, so ours will never be complete. <button type="button" data-goto="m">Measure your rack instead</button> and you will have a definite answer in three questions.</div>' +
        '</div>' +
        '<div class="bmrf-brands"><details><summary>Or browse by brand</summary><div id="bmrf-brands"></div></details></div>' +
      '</div>' +

      '<div class="bmrf-pane" id="bmrf-pm" hidden>' +
        '<details class="bmrf-howto"><summary>How to measure it, and what to measure with</summary><div class="bmrf-hb">' +
          '<div class="bmrf-tip"><h5>A tape measure is enough for the upright</h5><p>Measure straight across the flat front face of the vertical post. Do not measure corner to corner: the diagonal of a 75 mm post is 106 mm, and that is the most common mistake.</p><p>If the number lands between two sizes you are probably on an imperial post. 2 inches reads as 51, 2.4 inches as 61, 3 inches as 76.</p></div>' +
          '<div class="bmrf-tip"><h5>Hole spacing needs more care</h5><p>This decides whether the Fixed mount bolts up, and the difference between a 50 mm rack and a 2 inch rack is under a millimetre per hole. One gap will not tell them apart, and it does not need to.</p><div class="bmrf-trick"><strong>Measure ten gaps, not one.</strong> Put the tape on the centre of one hole, count ten holes down, read the centre of the tenth, divide by ten.<code>500 mm over 10 gaps = 50 mm spacing · 508 mm over 10 gaps = 2 inch spacing</code>Both work with the Fixed mount. Anything near 250, 350, 750 or 1000 over ten gaps does not.</div></div>' +
          '<div class="bmrf-tip"><h5>Using the Measure app on an iPhone</h5><p>Open Measure, point at the upright, drag from one edge of the face to the other. On a Pro model with LiDAR it lands within a couple of millimetres, which is plenty to tell 50 from 60 from 75.</p><p><strong>Do not use it for hole spacing.</strong> It cannot separate 50 mm from 50.8 mm, and it does not need to, because the ten-gap method above solves that with a tape measure. Android camera measure tools behave the same way.</p></div>' +
          '<div class="bmrf-tip"><h5>The daylight test</h5><p>Hold your phone torch against a hole on one side of the upright and look at the same hole from the other side. Light through means the holes pass straight through and the Fixed mount can bolt through them.</p><p>If the back of the hole is closed, or the hole is threaded, the Fixed mount will not work even if every other measurement is right.</p></div>' +
          '<div class="bmrf-tip"><h5>Shortcut: check the manufacturer first</h5><p>Most rack makers publish the upright size and hole spacing under a Specifications tab. If you can find the model number on a sticker on the frame, searching that number plus the word "specifications" beats measuring.</p></div>' +
        '</div></details>' +

        '<div class="bmrf-q"><span class="qn">Question 1 of 3</span><h3>How wide is the upright?</h3><p class="qh">Measure across the front face of the vertical post, not the base.</p><div class="bmrf-ch">' +
          '<button class="bmrf-c" data-g="u" data-v="50.8" aria-pressed="false">50 mm / 2 in</button>' +
          '<button class="bmrf-c" data-g="u" data-v="60" aria-pressed="false">60 mm</button>' +
          '<button class="bmrf-c" data-g="u" data-v="60.96" aria-pressed="false">2.4 in</button>' +
          '<button class="bmrf-c" data-g="u" data-v="70" aria-pressed="false">70 mm</button>' +
          '<button class="bmrf-c" data-g="u" data-v="76.2" aria-pressed="false">75 mm / 3 in</button>' +
          '<button class="bmrf-c" data-g="u" data-v="other" aria-pressed="false">Something else</button>' +
        '</div><div class="bmrf-inl" data-cu="u" hidden><input type="number" class="bmrf-in" step="0.1" min="10" max="200" placeholder="80" aria-label="Upright width in millimetres"><span>mm across the face</span></div></div>' +

        '<div class="bmrf-q"><span class="qn">Question 2 of 3</span><h3>How far apart are the holes?</h3><p class="qh">Centre to centre. Skip this if your upright is 75 mm, it does not affect the Sliding mount.</p><div class="bmrf-ch">' +
          '<button class="bmrf-c" data-g="p" data-v="25.4" aria-pressed="false">25 mm / 1 in</button>' +
          '<button class="bmrf-c" data-g="p" data-v="35" aria-pressed="false">35 mm</button>' +
          '<button class="bmrf-c" data-g="p" data-v="50.8" aria-pressed="false">50 mm / 2 in</button>' +
          '<button class="bmrf-c" data-g="p" data-v="75" aria-pressed="false">75 mm</button>' +
          '<button class="bmrf-c" data-g="p" data-v="100" aria-pressed="false">100 mm</button>' +
          '<button class="bmrf-c" data-g="p" data-v="other" aria-pressed="false">Something else</button>' +
        '</div><div class="bmrf-inl" data-cu="p" hidden><input type="number" class="bmrf-in" step="0.1" min="5" max="400" placeholder="80" aria-label="Hole spacing in millimetres"><span>mm centre to centre</span></div></div>' +

        '<div class="bmrf-q"><span class="qn">Question 3 of 3</span><h3>Do the holes go all the way through?</h3><p class="qh">Look through a hole from one side. Daylight out the other side means they pass straight through.</p><div class="bmrf-ch">' +
          '<button class="bmrf-c" data-g="t" data-v="yes" aria-pressed="false">Yes, straight through</button>' +
          '<button class="bmrf-c" data-g="t" data-v="no" aria-pressed="false">No, closed at the back</button>' +
        '</div></div>' +
      '</div>' +

      '<div class="bmrf-pane" id="bmrf-pc" hidden>' +
        '<p class="bmrf-vb">Both mounts hold the same Gym Nano. Only the way it attaches to the rack differs.</p>' +
        '<div class="bmrf-cmp"><table><thead><tr><th></th><th>Sliding Rack Mount</th><th>Fixed Rack Mount</th></tr></thead><tbody>' +
          '<tr><th>Upright size</th><td><strong>75 x 75 mm only</strong><br>(3 x 3 in)</td><td>50 x 50 mm to 75 x 75 mm<br>includes 60 x 60 mm</td></tr>' +
          '<tr><th>Hole diameter</th><td>15 mm (5/8 in) or larger</td><td>15 mm (5/8 in) or larger</td></tr>' +
          '<tr><th>Hole spacing</th><td>None required</td><td><strong>Two holes 2 in (50.8 mm) apart</strong>, passing straight through</td></tr>' +
          '<tr><th>Orientation</th><td>90 degrees to the machine</td><td>0 degrees, in line with the machine</td></tr>' +
          '<tr><th>Height</th><td>Slides to any height on the upright</td><td>Bolted at one height, move the bolts to change it</td></tr>' +
        '</tbody></table></div>' +
        '<p class="bmrf-hint">If both fit your rack, take the Sliding mount. It moves up and down without tools.</p>' +
        '<div class="bmrf-act"><button type="button" class="bmrf-btn" data-goto="s">Find my rack</button><button type="button" class="bmrf-btn g" data-goto="m">Measure it</button></div>' +
      '</div>' +

      '<div id="bmrf-vw" hidden style="display:flex;flex-direction:column;gap:1.2rem">' +
        '<div class="bmrf-v" id="bmrf-v"></div>' +
        '<div class="bmrf-dis"><span class="dx">Check first</span><div>Treat this as a guide, not a guarantee. Manufacturers change upright profiles and hole patterns between production runs without changing the model name, and this data comes from published specifications rather than from a rack in front of us. <strong>Measure your own upright and hole spacing before you order.</strong> If you are unsure, send us your rack make and model and we will confirm the fit before your order ships.</div></div>' +
      '</div>';
  }

  function load() {
    if (RACKS) return Promise.resolve();
    if (loading) return loading;
    // Loaded as a script rather than fetched: Shopify rewrites .json theme assets
    // (it pretty-prints them, inflating 58 KB to 96 KB) and leaves .js alone.
    loading = new Promise(function (resolve, reject) {
      if (window.BMRF_RACKS) { resolve(); return; }
      var url = window.BMRF_DATA_URL;
      if (!url) { reject(new Error('no data url')); return; }
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () { window.BMRF_RACKS ? resolve() : reject(new Error('empty payload')); };
      s.onerror = function () { reject(new Error('network')); };
      document.head.appendChild(s);
    }).then(function () {
      RACKS = (window.BMRF_RACKS && window.BMRF_RACKS.racks) || [];
      if (!RACKS.length) throw new Error('empty payload');
    }).catch(function (e) { RACKS = null; loading = null; throw e; });
    return loading;
  }

  function ensure() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'bmrf';
    dlg.innerHTML = shell();
    document.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.querySelector('#bmrf-x').addEventListener('click', function () { dlg.close(); });
    return dlg;
  }

  function open() {
    ensure();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    if (RACKS) return;
    load().then(function () {
      dlg.querySelector('#bmrf-body').innerHTML = panes();
      wire();
    }).catch(function () {
      dlg.querySelector('#bmrf-body').innerHTML =
        '<div class="bmrf-load">We could not load the rack list just now. Please refresh, or send us your rack make and model and we will confirm the fit for you.</div>';
    });
  }

  window.BMRF = { open: open, judge: judge };
})();
